import { useMemo } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import * as actions from "../../_redux/school-reports/SchoolReportsAction";
import {
  DeleteButton,
  ExportButton,
  FormButton,
  copy,
  deletionAlert,
  exportToExcel,
  exportToPDF,
  getAuthorities,
  noRecordsAlert,
  print,
  redirectToPages,
  resultAlert
} from "../../../../../_helpers/Helpers";
import { 
  Card, 
  CardBody, 
  CardHeader,
  CardHeaderToolbar,
  ModalProgressBar
} from "../../../../../_metronic/_partials/controls";
import { useSchoolReportsUIContext } from "./SchoolReportsUIContext";
import { SchoolReportsFilter } from "./school-reports-filter/SchoolReportsFilter";
import { SchoolReportsTable } from "./school-reports-table/SchoolReportsTable";

export function SchoolReportsCard() {
  // School Reports Card UI Context
  const schoolReportsUIContext = useSchoolReportsUIContext();
  const schoolReportsUIProps = useMemo(() => {
    return {
      ids: schoolReportsUIContext.ids,
      setIds: schoolReportsUIContext.setIds,
      queryParams: schoolReportsUIContext.queryParams,
      openNewSchoolReportPage: schoolReportsUIContext.openNewSchoolReportPage,
    };
  }, [schoolReportsUIContext]);
    
  // Getting curret state of School Reports list from store (Redux)
  const { currentState } = useSelector(
    (state) => ({ currentState: state.schoolReports }),
    shallowEqual
  );
  const { actionsLoading, isSuccess, type, authorities } = currentState;

  // Authority Parameters
  const { isExportationAuthorized, isAdditionAuthorized, isDeletionAuthorized } = getAuthorities(authorities);

  // School Reports Redux state
  const dispatch = useDispatch();

  // Yetki ve Hata Kontrolleri
  if (isSuccess === false) return redirectToPages(type);

  /** Belli Bir Branş Listesini Excele Aktarır */
  // const exportBranchesToExcel = () => {
  //   dispatch(actions.getAllBranches(schoolReportsUIProps.queryParams)).then(entities => {
  //     if (entities.isSuccess === false) return;
  //     const rows = [];
  //     const widths = [30];
  //     const columns = ["Adı"];
  //     entities.forEach(entity => rows.push([entity.name]));
  //     const filename = "Branş Listesi"
  //     exportToExcel({ columns, rows, widths, filename });
  //   });
  // }

  /** Belli Bir Branş Listesini PDF e Aktarır */
  // const exportBranchesToPDF = () => {
  //   dispatch(actions.getAllBranches(schoolReportsUIProps.queryParams)).then(entities => {
  //     if (entities.isSuccess === false) return;
  //     const views = [ 
  //       {
  //         header: "Adı",
  //         rows: entities.map(entity => entity.name)
  //       }
  //     ];
  
  //     const filename = "Branş Listesi";
  //     exportToPDF(views, filename);
  //   });
  // }

  /** Belli Bir Branş Listesini Yazdırma Penceresini Açar */
  // const printBranches = () => {
  //   dispatch(actions.getAllBranches(schoolReportsUIProps.queryParams)).then(entities => {
  //     if (entities.isSuccess === false) return;
  //     const data = [];    
  //     const header = "Branş Listesi";
  //     const properties = ["Adı"];

  //     entities.forEach(entity => {
  //       data.push({
  //         "Adı": entity.name
  //       });
  //     });

  //     print({ data, properties, header });
  //   });
  // }

  /** Belli Bir Okul Karnesi Listesini Panoya Kopyalar */
  const copySchoolReports = () => {
    dispatch(actions.getAllSchoolReports(schoolReportsUIProps.queryParams)).then(entities => {
      if (entities.isSuccess === false) return;
      const rows = [];
      const header = "Branş Listesi";
      const columns = ["Adı"];
      entities.forEach(entity => rows.push([entity.name]));
      copy({ header, columns, rows });
    });
  }

  /** Belli Bir Okul Karnesi Listesini Siler */
  const deleteSchoolReports = (ids) => {
    if (typeof ids === 'string') ids = ids.split(",");
  
    if (ids.length < 1) {
      noRecordsAlert();
      return;
    }  
    deletionAlert().then(result => {
      if (result.isConfirmed) dispatch(actions.deleteSchoolReports(ids)).then(result => onResult(result));
    });
  }

  const onResult = ({ isSuccess, type, message }) => {
    resultAlert(type, message);

    if (isSuccess) {
      setTimeout(() => {
        schoolReportsUIProps.setIds([]);
        dispatch(actions.getSchoolReports(schoolReportsUIProps.queryParams));        
      }, 2500);
    }
  };
  
  const title = <>Okul Karnesi Listesi{schoolReportsUIProps.ids.length > 0 ?
                  <> [Seçilen Kayıt Sayısı: <span style={{color:"red"}}>{schoolReportsUIProps.ids.length}</span>]</> :
                   ""}
                </>;

  return (
    <Card>
      {actionsLoading && <ModalProgressBar />}
      <CardHeader title={title}>
        {
          (isExportationAuthorized || isAdditionAuthorized || isDeletionAuthorized) &&
          <CardHeaderToolbar>
            {
              isExportationAuthorized &&
              <ExportButton
                // exportToExcel={exportBranchesToExcel}
                // exportToPDF={exportBranchesToPDF}
                // print={printBranches}
                copy={copySchoolReports}
              />
            }
            {
              isAdditionAuthorized && 
              <FormButton 
                path="Navigation/Plus"
                title="Yeni Okul Karnesi"
                method={schoolReportsUIProps.openNewSchoolReportPage}
              />
            }
            {
              isDeletionAuthorized && 
              <DeleteButton
                title="Seçilenleri Sil"
                method={() => deleteSchoolReports(schoolReportsUIProps.ids)}
              />
            }
          </CardHeaderToolbar>
        }        
      </CardHeader>
      <CardBody>
        <SchoolReportsFilter />
        <SchoolReportsTable
          deleteSchoolReports={deleteSchoolReports}
        />
      </CardBody>
    </Card>
  );
}